import { MouseEvent, useEffect, useRef, useState } from 'react';

export const useTextCopiedTimer = (
  text: string,
  onCopy?: (e?: MouseEvent) => void,
  duration: number = 3000,
): [boolean, () => void] => {
  const [textCopied, setTextCopied] = useState(false);
  const timer = useRef(null);

  const copyTextToClipboard = (e?: MouseEvent) => {
    onCopy?.(e);
    navigator.clipboard.writeText(text).then(() => {
      setTextCopied(true);
      timer.current = setTimeout(() => {
        setTextCopied(false);
        timer.current = null;
      }, duration);
    });
  };

  useEffect(
    () => () => {
      if (timer.current) {
        clearTimeout(timer.current);
      }
    },
    [],
  );

  return [textCopied, copyTextToClipboard];
};
